import React from 'react';

var MarketplaceButton = React.createClass({
    render: function(){
      return(
           	<button className="btn__lg bg-very_light">
           		<i className="fa fa-tag"></i> 
           		<span>Marketplace</span>
           	</button>
        );
    }
});

export {MarketplaceButton};


/** WEBPACK FOOTER **
 ** ./html/components/MarketplaceButton.jsx
 **/